if (!customElements.get('wls-product-info')) {
    class WLSProductInfo extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                gallery: 'js-wls-product-info-gallery',
                thumbs: 'js-wls-product-info-gallery-thumb',
                list: 'splide__list',
                item: 'splide__slide',
            };
            this.elements = {
                gallery: this.querySelector(`.${this.classes.gallery}`),
                thumbs: this.querySelector(`.${this.classes.thumbs}`),
                list: this.querySelector(`.${this.classes.list}`),
                items: this.querySelectorAll(`.${this.classes.item}`),
            }

            this.resizeHandler = this.handleResize.bind(this);
        }

        connectedCallback() {
            if (this.checkIfEmpty()) return;
            this.init();
            window.addEventListener('resize', this.resizeHandler);
        }

        disconnectedCallback() {
            if (this.splide) {
                this.splide.destroy(true);
                this.splide = null;
            }

            window.removeEventListener('resize', this.resizeHandler);

            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }
        }

        checkIfEmpty() {
            const listInner = this.elements.list;

            if (!listInner || !listInner.children.length) {
                this.style.display = 'none';
                return true;
            }

            return false;
        }

        init() {
            if (!this.shouldInitialize()) return;
            this.initializeSplide();
        }

        shouldInitialize() {
            if (!this.elements.gallery || !this.elements.items.length) return false;

            const slidesCount = this.elements.items.length;

            if (slidesCount <= 1 ) {
                return false;
            }
            return true;
        }

        handleResize() {
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }

            this.resizeTimeout = setTimeout(() => {
                const shouldInit = this.shouldInitialize();

                if (shouldInit && !this.splide) {
                    this.initializeSplide();
                } else if (!shouldInit && this.splide) {
                    this.splide.destroy(true);
                    this.splide = null;
                } else if (this.splide) {
                    this.splide.refresh();
                }
            }, 300);
        }

        initializeSplide() {
            const main = new Splide(this.elements.gallery, {
                type      : 'fade',
                pagination: false,
                arrows    : false,
                cover     : true,
            });

            const thumbs = new Splide(this.elements.thumbs, {
                rewind      : true,
                isNavigation: true,
                gap         : 16,
                focus       : 'center',
                pagination  : false,
                cover       : true,
                arrows      : false,
                perPage: 5,
              });

              main.sync(thumbs);
              main.mount();
              thumbs.mount();

              this.splide = main;
        }
    }

    customElements.define('wls-product-info', WLSProductInfo);
}
